import React, { useMemo } from 'react';

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Navbar from './layouts/navbar';
import PresalePart from "./pages/presalePart"
import Claim from './pages/claim';
import ThemeContext from './context/themeContext';

import './App.css';
import SOL from "./assets/img/sol.svg"
import USDC from "./assets/img/usdc.svg"
import USDT from "./assets/img/usdt.png"
import JUP from "./assets/img/jup.svg"
import Dive from './pages/dive';
import Price from './pages/price';
import Tokenomics from './pages/tokenomics';
import HowTo from './pages/howTo';
import Copyright from './pages/copyright';
import styles from './styles.module.css'
import { useSpring, animated, config } from '@react-spring/web'

function App() {
  const [{ background }] = useSpring(
    () => ({
      from: { background: 'var(--step0)' },
      to: [
        { background: 'var(--step0)' },
        { background: 'var(--step1)' },
        { background: 'var(--step2)' },
        { background: 'var(--step3)' },
        { background: 'var(--step4)' },
      ],
      config: config.molasses,
      loop: {
        reverse: true,
      },
    }),
    []
  )

  const tokens = [
    { ft: "SOL", icon: SOL },
    // { ft: "JUP", icon: JUP },
    // { ft: "USDC", icon: USDC },
    // { ft: "USDT", icon: USDT },
  ];
  return (
    <div className="App bg-[#071619] bg-center bg-cover " >
      <ThemeContext.Provider value={tokens}>
      <animated.div className={styles.block} style={{ background }} >
          <div className={styles.block} />
          <div className={styles.block} />
          <Navbar></Navbar>
          <div className='px-5 md:px-10 lg:px-0 pb-[160px] flex flex-col'>
            <PresalePart />
            <Claim />
            <Dive />
          </div>
          <Price />
          <div className='py-[142px] flex flex-col'>
            <Tokenomics />
            <HowTo />
          </div>
          <Copyright />
          <ToastContainer autoClose={3000} draggableDirection="x" toastStyle={{ backgroundColor: "#05bfc4", color: "white" }} />
        </animated.div>
      </ThemeContext.Provider>
    </div>
  );
}

export default App;
